import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class ProfileService {

    updateProfilePhoto(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/update-my-photo/";

        return axios.put(api_url, data, config);
    }


    deleteProfilePhoto(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const data = null;
        const api_url = BACKEND_URL + "/api/hr/delete-my-photo/";

        return axios.post(api_url, data, config);
    }


    getSocialAccountsList(token) {

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/social/my-social-accounts/";

        return axios.get(api_url, config);
    };


    addSocialAccounts(token, data) {

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/social/my-social-accounts-update/";

        return axios.post(api_url, data, config);
    };


    changePassword(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/changepassword/";

        return axios.post(api_url, data, config);
    }


    updateProfileDetails(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const api_url = BACKEND_URL + "/api/hr/update-my-info/";

        return axios.put(api_url, data, config);
    }

}

export default new ProfileService();